import { create } from "zustand";
import { createJSONStorage, persist, StateStorage } from "zustand/middleware";
import { unifiedZustandStorage } from '../../../../../libs/helpers';
const storage = unifiedZustandStorage;

// const storage: StateStorage = {
//   getItem: async (name: string): Promise<string | null> => {
//     // console.log(name, 'has been retrieved')
//     return (await get(name)) || null;
//   },
//   setItem: async (name: string, value: string): Promise<void> => {
//     // console.log(name, 'with value', value, 'has been saved')
//     await set(name, value);
//   },
//   removeItem: async (name: string): Promise<void> => {
//     // console.log(name, 'has been deleted')
//     await del(name);
//   },
// };

type State = {
  videoContenedorVacio: string;
  videoPisoExterno: string;
  dateVideoContenedorVacio: string | Date;
  dateVideoPisoExterno: string | Date;
  container: string;
};

type Action = {
  setVideoContenedorVacio: (
    videoContenedorVacio: State["videoContenedorVacio"], src:boolean
  ) => void;
  setVideoPisoExterno: (videoPisoExterno: State["videoPisoExterno"], src:boolean) => void;
  setContainer: (videoPisoExterno: State["container"]) => void;
  getVideos: () => Promise<State>;
  onClear: () => void;
};

// Create your store, which includes both state and (optionally) actions
export const useVideoStore = create<
  State & Action,
  [["zustand/persist", unknown]]
>(
  persist(
    (set, get) => ({
      videoContenedorVacio: "",
      videoPisoExterno: "",
      dateVideoContenedorVacio: "",
      dateVideoPisoExterno: "",
      container: "",
      setVideoContenedorVacio: (videoContenedorVacio, src) => {
        if(src){
          set(() => ({
            videoContenedorVacio,
            dateVideoContenedorVacio: new Date(),
          }));
          return;
        }
        if (!videoContenedorVacio) {
          set(() => ({
            videoContenedorVacio: "",
            dateVideoContenedorVacio: "",
          }));
          return;
        }
      
        const url = URL.createObjectURL(videoContenedorVacio as unknown as Blob);
        set(() => ({
          videoContenedorVacio: url as string,
          dateVideoContenedorVacio: new Date(),
        }));
      },
      setVideoPisoExterno: (videoPisoExterno, src) => {
        if(src){
          set(() => ({
            videoPisoExterno,
            dateVideoPisoExterno: new Date(),
          }));
          return;
        }
        if (!videoPisoExterno) {
          set(() => ({
            videoPisoExterno: "",
            dateVideoPisoExterno: "",
          }));
          return;
        }
        // const reader = new FileReader();
        // reader.readAsDataURL(videoPisoExterno as unknown as Blob);
        // reader.onloadend = function () {
        //   const base64data = reader.result;
        //   set(() => ({
        //     videoPisoExterno: base64data as string,
        //     dateVideoPisoExterno: new Date(),
        //   }));
        // };
        const url = URL.createObjectURL(videoPisoExterno as unknown as Blob);
           set(() => ({
            videoPisoExterno: url as string,
            dateVideoPisoExterno: new Date(),
          }));
      },
      setContainer: (container) => set(() => ({ container })),

      getVideos: async () => {
        const v1 = get().videoContenedorVacio
        const v2 = get().videoPisoExterno
        const vcv = await convertObjectURLToBase64(v1);
        const vpe = await convertObjectURLToBase64(v2);

        return {
          videoContenedorVacio: vcv as string,
          videoPisoExterno: vpe as string,
          dateVideoContenedorVacio: get().dateVideoContenedorVacio,
          dateVideoPisoExterno: get().dateVideoPisoExterno,
          container: get().container,
        };
      },
      onClear: () => {
        set(() => ({
          videoContenedorVacio: "",
          videoPisoExterno: "",
          dateVideoContenedorVacio: "",
          dateVideoPisoExterno: "",
          container: "",
        }));
      },
    }),
    {
      name: "workflow-container-empty-videos", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => storage), // (optional) by default, 'localStorage' is used
    }
  )
);

const convertObjectURLToBase64 = async (objectURL:any) => {
  const response = await fetch(objectURL);

  const blob = await response.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob); // Convierte el Blob a base64

    reader.onloadend = () => {
      resolve(reader.result); // El resultado es el base64
    };

    reader.onerror = reject;

  });
};

  // const reader = new FileReader();
        // reader.readAsDataURL(videoContenedorVacio as unknown as Blob);
        // reader.onloadend = function () {
        //   const base64data = reader.result;
        //   set(() => ({
        //     videoContenedorVacio: base64data as string,
        //     dateVideoContenedorVacio: new Date(),
        //   }));
        // };